import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerRegistrationService,
  CustomerRegistrationModel,
  CustomerRegistrationRequest,
  CustomerAddressRequest,
  CustomerCompanyDetailsRequest,
  CustomerFreightProfileModel,
  CustomerRegistrationTeamRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerRegistrationApiService {
  constructor(private apiService: CustomerRegistrationService) {}

  public registerCustomer(body: CustomerRegistrationRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistration(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public saveAddress(customerId: string, body: CustomerAddressRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistrationAddress(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public saveCompanyDetails(customerId: string, body: CustomerCompanyDetailsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistrationCompanyDetails(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public saveFreightProfile(customerId: string, customerFreightProfileModel: CustomerFreightProfileModel, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistrationFreightProfile(customerId, customerFreightProfileModel, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getRegistration(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistrationGet(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public saveTeam(customerId: string, body: CustomerRegistrationTeamRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistrationTeam(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public skipTeam(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerRegistrationModel> {
    return this.apiService.customerRegistrationTeamSkip(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
